import { AccountCircle, AddCircle, Send } from '@mui/icons-material';
import { Avatar, Button, IconButton, TextField, Typography } from '@mui/material';
import React, { useContext, useState } from 'react'
import { AsuntosContext } from '../../pages/asuntos/AsuntosPage'
import dayjs from 'dayjs';
import { AvancesComponent } from './AvancesComponent';
import { EnviarComentario } from '../../helpers/AsuntosHelper';
import { AuthContext } from '../../context/AuthContext';
export const ResumenAsuntoComponent = () => {
    const  {modalAgregaAvance, setModalAgregaAvance,asuntoSeleccionado, setAsuntoSeleccionado, tareaSeleccionada} = useContext(AsuntosContext);
    const [comentario, setComentario] = useState();
    const {usuario} = useContext(AuthContext);
    const [actualizarAvances, setActualizarAvances] = useState(0);

    console.log('asunto recibido', asuntoSeleccionado);

    const enviarComentario = () => {
        let idAsunto =0;
        if(tareaSeleccionada?.IdAsunto) {
            idAsunto = tareaSeleccionada?.IdAsunto
        } else {
            idAsunto = asuntoSeleccionado?.IdAsunto
        }
        EnviarComentario(idAsunto,comentario, usuario.IdUsuario).then(response => {
            setComentario('');
        });
        setActualizarAvances(actualizarAvances+1);
    }

    const tituloResumen = (titulo) => {
        return (
            <div
            style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center',
                backgroundColor:'transparent'
            }}
        >
            <Typography
                style={{
                    fontSize:16,
                    fontWeight:'500'
                }}
            >{titulo}</Typography>

        </div>

        )
    }

  return (
    <>
    <div
        style={{
            display:'flex',
            flexDirection:'column',
            flex:15,
            borderRadius:10,
            backgroundColor:'white',
            padding:10
        }}
    >
        <div
            style={{
                display:'flex',
                flexDirection:'row',
                flex:70
            }}
        >
            <div
                style={{
                    display:'flex',
                    flexDirection:'column',
                    justifyContent:'flex-start',
                    flex:90
                }}
            >

            
            <div
                style={{
                    display:'flex',
                    flexDirection:'row',
                    flex:20,
                    alignItems:'center',
                    backgroundColor:'transparent'
                    
                }}
            >
                <div style={{
                    display:'flex',
                    flexDirection:'column',
                    flex:40,
                    backgroundColor:'transparent'
                }}>
                    {tituloResumen('Folio')}           
                </div>
                <div style={{
                    display:'flex',
                    flexDirection:'column',
                    flex:80,
                    backgroundColor:'transparent'
                }}>
                    <div
                        style={{
                            display:'flex',
                            flexDirection:'row',
                            alignItems:'center'
                        }}
                    >
                        {
                            tareaSeleccionada?.IdAsunto ? (
                                <Typography>{tareaSeleccionada?.IdAsunto}</Typography>

                            ):(
                                <Typography>{asuntoSeleccionado?.IdAsunto}</Typography>

                            )
                        }
                    </div>
                </div>
            </div>
            <div
                style={{
                    display:'flex',
                    flexDirection:'row',
                    flex:20,
                    alignItems:'center',
                    backgroundColor:'transparent'
                    
                }}
            >
                <div style={{
                    display:'flex',
                    flexDirection:'column',
                    flex:40,
                    backgroundColor:'transparent'
                }}>
                    {tituloResumen('Responsable')}           
                </div>
                <div style={{
                    display:'flex',
                    flexDirection:'column',
                    flex:80,
                    backgroundColor:'transparent'
                }}>
                    <div
                        style={{
                            display:'flex',
                            flexDirection:'row',
                            alignItems:'center'
                        }}
                    >
                        {
                            tareaSeleccionada?.NombreResponsable ? (
                                <Typography>{tareaSeleccionada?.NombreResponsable}</Typography>

                            ):(
                                <Typography>{asuntoSeleccionado?.NombreResponsable}</Typography>

                            )
                        }
                    </div>
                </div>
            </div>
            <div
                style={{
                    display:'flex',
                    flexDirection:'row',
                    flex:20,
                    alignItems:'center',
                    backgroundColor:'transparent'
                    
                }}
            >
                <div style={{
                    display:'flex',
                    flexDirection:'column',
                    flex:40,
                    backgroundColor:'transparent'
                }}>
                    {tituloResumen('Asignado el')}           
                </div>
                <div style={{
                    display:'flex',
                    flexDirection:'column',
                    flex:80,
                    backgroundColor:'transparent'
                }}>
                    <div
                        style={{
                            display:'flex',
                            flexDirection:'row',
                            alignItems:'center'
                        }}
                    >
                        {
                            tareaSeleccionada?.Fechasolicitud ? (
                                <Typography>{dayjs(tareaSeleccionada?.FechaSolicitud).format('DD/MM/YYYY HH:mm')} </Typography>

                            ): (
                                <Typography>{dayjs(asuntoSeleccionado?.FechaSolicitud).format('DD/MM/YYYY HH:mm')} </Typography>

                            )
                        }
                    </div>
                </div>
            </div>
            <div
                style={{
                    display:'flex',
                    flexDirection:'row',
                    flex:20,
                    alignItems:'center',
                    backgroundColor:'transparent'
                    
                }}
            >
                <div style={{
                    display:'flex',
                    flexDirection:'column',
                    flex:40,
                    backgroundColor:'transparent'
                }}>
                    {tituloResumen('Fecha esperada de cierre')}           
                </div>
                <div style={{
                    display:'flex',
                    flexDirection:'column',
                    flex:80,
                    backgroundColor:'transparent'
                }}>
                    <div
                        style={{
                            display:'flex',
                            flexDirection:'row',
                            alignItems:'center',
                            justifyContent:'space-between'
                        }}
                    >
                        <Typography>{dayjs(asuntoSeleccionado?.FechaEsperada).format('DD/MM/YYYY HH:mm')} </Typography>
                        <Button
                            onClick={() => setModalAgregaAvance(true)}
                            variant='outlined'
                            size='small'
                            style={{
                                textTransform:'unset',
                                color:'#002D72'
                            }}
                        ><AddCircle /> Agregar avance</Button>
                    </div>
                </div>
            </div>

        </div>
            <div
                style={{
                    display:'flex',
                    flexDirection:'row',
                    flex:20,
                    heigth:'100%',
                    backgroundColor:'transparent',
                    justififyContent:'center',
                    alignItems:'center'
                }}
                >
                <div
                    style={{
                        display:'flex',
                        flexDirection:'column',
                        backgroundColor:'transparent',
                        height:'100%',
                        width:'100%',
                        justififyContent:'center',
                        alignItems:'center'
                    }}
                >
                    <div
                        style={{
                            display:'flex',
                            flex:1,
                            width:'100%',
                            backgroundColor:'transparent',
                            justifyContent:'center',
                            alignItems:'center',
                            backgroundColor:'transparent'
                        }}
                    >
                        <AccountCircle style={{color:'lightgray', fontSize:80}} />
                        </div>
                </div>

            </div>
        </div>
    </div>
    <div
        style={{
            display:'flex',
            flexDirection:'column',
            flex:70,
            borderRadius:10,
            backgroundColor:'lightgray',
            marginTop:10
        }}
    >
        {
            asuntoSeleccionado?.IdAsunto || tareaSeleccionada?.IdAsunto ? (
        <div
            style={{
                display:'flex',
                flexDirection:'row',
                backgroundColor:'white',
                borderRadius:10, 
                padding:5,
                alignItems:'flex-end',
                margin:10
            }}
        >
        <TextField
            size='small'
            margin="dense"
            id="name"
            multiline={false}
            rows={1}
            name="txtTipoActivo"
            label="Comentario"
            type="text"
            sx={{borderBottom:0}}
            fullWidth
            variant="standard"
            required={true}

            onChange={(e) => setComentario(e.target.value)}
            value={comentario}
          />
          <IconButton onClick={() =>{enviarComentario()}}><Send style={{marginBottom:5, color:'green'}} /></IconButton>
        </div>
            ):null
}
        <div
            style={{
                display:'flex',
                flexDirection:'row',
                padding:20
            }}
        >
            <AvancesComponent actualizarAvances={actualizarAvances} />
        </div>
    </div>
    </>
  )
}
